import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./shared.css']
})
export class LoginComponent {
  email = '';
  password = '';
  error = '';
  constructor(private auth: AuthService, private router: Router) {}
  login(): void {
    this.error = '';
    this.auth.login(this.email, this.password).subscribe({
      next: (res: any) => {
        const role = (res?.user?.role || '').toLowerCase();
        if (role === 'doctor') this.router.navigate(['/doctor']);
        else if (role === 'medical assistant') this.router.navigate(['/assistant']);
        else this.router.navigate(['/patient']);
      },
      error: (err) => this.error = err?.error?.error || 'Login failed'
    });
  }
}
